<template>
  <div class="AppFileManager">
    <v-expansion-panels v-model="isOpen" class="AppFileManager__panels">
      <v-expansion-panel class="AppFileManager__panel">
        <v-expansion-panel-title class="AppFileManager__panel__header text-text-primary">
          <slot name="header"/>
          <template #actions>
            <AppButton icon>
              <app-material-icon
                name="keyboard_arrow_up"
                class="AppFileManager__modelIcon"
                :class="{'AppFileManager__modelIcon--open': computedIsOpen}"
              />
            </AppButton>
            <AppButton icon @click.stop="$emit('cancel')">
              <app-material-icon name="close" class="AppFileManager__cancelIcon"/>
            </AppButton>
          </template>
        </v-expansion-panel-title>
        <v-expansion-panel-text class="AppFileManager__panel__content">
          <slot name="content"/>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import AppButton from '@/common/buttons/AppButton.vue'
export default {
  name: 'AppFileManager',
  components: { AppButton },
  data () {
    return {
      isOpen: 0,
    }
  },
  computed: {
    computedIsOpen () {
      return typeof this.isOpen === 'number'
    },
  },
}
</script>

<style scoped lang="scss">
@import "vuetify/settings";

.AppFileManager {
  position: fixed;
  bottom: 0;
  width: 100%;
  max-width: 450px;
  z-index: 2000;
  @media #{map-get($display-breakpoints, 'md-and-up')} {
    right: 50px;
  }

  &__panels,
  &__panel {
    border-radius: 8px 9px 0 0 !important;
  }

  &__panels {
    box-shadow: 0 4px 30px rgba(148, 148, 148, 0.3);
    border: 1px solid #e0e0e0;
  }

  &__panel {
    &__header {
      min-height: 56px;
      border-bottom: 1px solid #eee;
      font-size: 16px;
      font-weight: 500;
    }
    &__content {
      padding-top: 8px;
    }
  }

  &__modelIcon {
    transition: transform .3s;
    color: rgb(var(--v-theme-icon-primary));
    &--open {
      transform: rotate(180deg);
    }
  }
}
</style>
